import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqsEn = [
  {
    q: 'How much do frameless shower doors cost in Las Vegas?',
    a: 'Frameless shower doors in Las Vegas typically cost between $800 and $2,500 installed, depending on size, glass thickness, and hardware finish. We offer free in-home estimates — call (702) 604-2093 for an exact quote.',
  },
  {
    q: 'What is the best glass company in Las Vegas for shower doors?',
    a: 'Quinolux Glass & Mirrors is Las Vegas\'s top-rated custom glass company with 500+ five-star reviews. We specialize in frameless shower doors, glass railings, custom mirrors, and tub enclosures across Las Vegas, Henderson, Summerlin, and surrounding areas.',
  },
  {
    q: 'How long does shower door installation take in Las Vegas?',
    a: 'Most frameless shower door installations are completed in 1–2 hours. From your initial measurement appointment to final installation, the typical turnaround is 5–7 business days.',
  },
  {
    q: 'Do you install glass railings in Henderson and Summerlin?',
    a: 'Yes! We install glass railings throughout the entire Las Vegas Valley including Henderson, Summerlin, North Las Vegas, Spring Valley, and Paradise. Glass stair railings and balcony railings are among our most popular services.',
  },
  {
    q: 'What types of shower doors do you offer in Las Vegas?',
    a: 'We offer frameless shower doors, sliding glass shower doors, tub enclosures, and custom shower glass installations. All glass is tempered safety glass and available in multiple thicknesses and hardware finishes.',
  },
  {
    q: 'Can you do custom mirror installation in Las Vegas?',
    a: 'Absolutely. We fabricate and install custom mirrors of any size and shape — bathroom mirrors, gym mirrors, salon mirrors, and decorative wall mirrors. We serve all Las Vegas Valley cities.',
  },
  {
    q: 'Do you offer shower door replacement in Las Vegas?',
    a: 'Yes, we handle shower door replacement for all types — frameless, sliding, and framed. Whether your existing door is damaged, outdated, or you simply want an upgrade, we can help.',
  },
  {
    q: 'Are glass railings safe and up to code in Las Vegas?',
    a: 'All our glass railing installations use tempered safety glass and comply with Nevada building codes. We handle all permits and inspections. Glass railings are extremely safe when properly installed.',
  },
];

const faqsEs = [
  {
    q: '¿Cuánto cuestan las puertas de ducha sin marco en Las Vegas?',
    a: 'Las puertas de ducha sin marco en Las Vegas típicamente cuestan entre $800 y $2,500 instaladas. Ofrecemos estimados gratuitos en su hogar — llame al (702) 604-2093.',
  },
  {
    q: '¿Cuál es la mejor empresa de vidrio en Las Vegas para puertas de ducha?',
    a: 'Quinolux Glass & Mirrors es la empresa de vidrio personalizado mejor calificada de Las Vegas con más de 500 reseñas de cinco estrellas. Nos especializamos en puertas de ducha sin marco, barandales de vidrio, espejos personalizados y cerramientos de bañera.',
  },
  {
    q: '¿Cuánto tiempo tarda la instalación de una puerta de ducha en Las Vegas?',
    a: 'La mayoría de las instalaciones de puertas de ducha sin marco se completan en 1–2 horas. El tiempo de entrega típico desde la medición hasta la instalación es de 5–7 días hábiles.',
  },
  {
    q: '¿Instalan barandales de vidrio en Henderson y Summerlin?',
    a: 'Sí. Instalamos barandales de vidrio en todo el Valle de Las Vegas incluyendo Henderson, Summerlin, North Las Vegas, Spring Valley y Paradise.',
  },
  {
    q: '¿Qué tipos de puertas de ducha ofrecen en Las Vegas?',
    a: 'Ofrecemos puertas de ducha sin marco, puertas corredizas, cerramientos de bañera e instalaciones de vidrio personalizadas. Todo el vidrio es vidrio de seguridad templado.',
  },
  {
    q: '¿Pueden hacer instalación de espejos personalizados en Las Vegas?',
    a: 'Absolutamente. Fabricamos e instalamos espejos personalizados de cualquier tamaño y forma — espejos de baño, espejos de gimnasio, espejos de salón y espejos decorativos.',
  },
  {
    q: '¿Ofrecen reemplazo de puertas de ducha en Las Vegas?',
    a: 'Sí, manejamos el reemplazo de puertas de ducha de todos los tipos — sin marco, corredizas y enmarcadas.',
  },
  {
    q: '¿Son seguros los barandales de vidrio y cumplen con el código en Las Vegas?',
    a: 'Todas nuestras instalaciones de barandales de vidrio usan vidrio de seguridad templado y cumplen con los códigos de construcción de Nevada. Manejamos todos los permisos e inspecciones.',
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { i18n } = useTranslation();
  const isEs = i18n.resolvedLanguage === 'es';
  const faqs = isEs ? faqsEs : faqsEn;

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-3 block">
            {isEs ? 'Preguntas Frecuentes' : 'FAQ'}
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-black" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {isEs ? 'Preguntas Sobre Nuestros Servicios de Vidrio en Las Vegas' : 'Questions About Glass Services in Las Vegas'}
          </h2>
        </div>

        <div className="flex flex-col divide-y divide-gray-100">
          {faqs.map((faq, i) => (
            <div key={i} className="py-5">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-start justify-between gap-4 text-left cursor-pointer group"
              >
                <h4 className="text-base font-semibold text-black group-hover:text-gray-700 transition-colors leading-snug">
                  <a id={`faq-${i}`}>{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full border border-gray-200 flex-shrink-0 mt-0.5 transition-all duration-300 ${openIndex === i ? 'bg-black border-black' : 'bg-white'}`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === i ? 'ri-subtract-line text-white' : 'ri-add-line text-gray-600'}`}></i>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-400 ease-out ${openIndex === i ? 'max-h-64 mt-3' : 'max-h-0'}`}>
                <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
